import GlobalRequest from '../api/global-request';

const GROUP_URL = 'v2/admin/permission/groups';

export default class GroupService {
    // for root user
    async getAllGroups(params) {
        return await GlobalRequest.getRequest(GROUP_URL, { params });
    }

    async createGroup(params) {
        return await GlobalRequest.postRequest(GROUP_URL, params);
    }

    async updateGroup(id, params) {
        return await GlobalRequest.patchRequest(`${GROUP_URL}/${id}`, params);
    }

    async getPermissionGroupUsers(groupId, companyId) {
        const response = await GlobalRequest.getRequest(`${GROUP_URL}/${groupId}/users`, {
            params: {
                company_id: companyId,
            },
        });
        return response.data;
    }

    async deleteGroup(id) {
        return await GlobalRequest.deleteRequest(`${GROUP_URL}/${id}`);
    }
}
